
import Vue, {PropType} from "vue";
import {HelperFunctions} from "@/scripts/Common/HelperFunctions";

export default Vue.extend({
  props: {
    MaxMonthlyTopUpAmount: Number,
    TopUpLimitPerMonth: Number,
    MaxCardLimit: Number,
    DefaultProvision: Number,
    HasEditRights: Boolean,
    expanded: {
      required: false,
      type: Array as PropType<Array<number>>,
      default() {
        return [1]
      }
    },
  },
  data: function () {
    return {
      valid: true,
      ruleConstants: {
        maxValue: 9999,
        minValue: 0,
        maxDecimals: 2,
        maxPercentValue: 100,
        minPercentValue: 0,
        maxPercentDecimals: 2,
      },
      internalExpand: this.expanded,
    };
  },
  computed: {
    MaxMonthlyTopUpAmountValue: {
      get() {
        return this.MaxMonthlyTopUpAmount
      },
      set(newValue) {
        this.$emit('update:MaxMonthlyTopUpAmount', newValue)
      }
    },
    TopUpLimitPerMonthValue: {
      get() {
        return this.TopUpLimitPerMonth;
      },
      set(newValue) {
        this.$emit('update:TopUpLimitPerMonth', newValue)
      }
    },
    MaxCardLimitValue: {
      get() {
        return this.MaxCardLimit;
      },
      set(newValue) {
        this.$emit('update:MaxCardLimit', newValue)
      }
    },
    DefaultProvisionValue: {
      get() {
        return this.DefaultProvision
      },
      set(newValue: number) {
        this.$emit('update:DefaultProvision', newValue)
      }
    },
    HasNoEditRights(): boolean {
      return !this.HasEditRights;
    },
    rules() {
      return {
        required: (value: string) => (value !== undefined && value !== null) || this.$t("Rules.Required"),
        max: (maxLength: number, value: string) =>
          value == undefined ||
          value.length <= maxLength ||
          this.$t("Rules.Max", {maxLength: maxLength}),
        minNumber: (value: number, minValue: number) =>
          value == undefined ||
          value >= minValue ||
          this.$t("Rules.MinNumber", {minValue: minValue}),
        maxNumber: (value: number, maxValue: number) =>
          value == undefined ||
          value <= maxValue ||
          this.$t("Rules.MaxNumber", {maxValue: maxValue}),
        maxDecimals: (value: number, maxDecimals: number) =>
          value == undefined ||
          this.getDecimalsCount(value) <= maxDecimals ||
          this.$t("Rules.MaxDecimals", {maxDecimals: maxDecimals}),
      };
    },
  },
  methods: {
    getDecimalsCount(value: number) {
      return HelperFunctions.GetDecimalsCount(value.toString())
    },
    validate() {
      (this.$refs.form as any).validate();
    },
  },
  watch: {
    valid: function (value) {
      this.$emit("ValidChanged", value);
      this.validate();
    },
    expanded: function (value) {
      this.internalExpand = value;
    }
  },
});
